module.exports = __webpack_public_path__ + "static/media/dragger.ff014a84.svg";